































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import BrandApi from '@/api/goods/brand'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    CustomForm,
    PicModal
  }
})
export default class GoodsBrandEdit extends AbpBase {
  filters = [
    {
      label: '品牌名称：',
      type: 'input',
      rule: { required: true, message: '请输入品牌名称', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '品牌首字母：',
      type: 'input',
      key: 'brandInitial'
    }
  ]
  brandId = null
  pictureUrl = null

  created() {
    if (this.$route.params['id']) {
      this.brandId = this.$route.params['id']
      this.getData()
    }
  }

  /**
   * 选择图片
   */
  picChange(event) {
    this.pictureUrl = event[0].url
  }

  onSubmit(form, valid) {
    if (valid) {
      if (!this.pictureUrl) {
        this.$Modal.error({
          title: '请选择图片'
        })
        return
      }
      let obj = form
      obj['picture'] = this.pictureUrl
      BrandApi.edit(this.brandId, obj).then(res => {
        this.$Message.success(this.brandId ? '修改成功' : '添加成功')
        this.$router.push({ name: 'brand', replace: true })
      })
    } else {
      this.$Message.error('验证失败')
    }
  }
  /**
   * 获取品牌信息
   */
  getData() {
    if (!this.brandId) {
      return
    }
    BrandApi.getDataById(this.brandId).then(res => {
      let $brandEdit: any = this.$refs.brandEdit
      $brandEdit.setForm(res.data)
      this.pictureUrl = res.data.picture
    })
  }
}
